import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'child-kpi-count',
  templateUrl: './kpi-count.component.html',
  standalone: true,

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataLengthComponent {
  dataLength: InputSignal<number| null> = input.required();
  entity: InputSignal<string> = input.required();
}
